import { render, staticRenderFns } from "./DeclinePrintOrder.vue?vue&type=template&id=5b23d46c"
import script from "./DeclinePrintOrder.vue?vue&type=script&lang=js"
export * from "./DeclinePrintOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports